// 公共文案
const COMMON = {
  common_thinking: 'Start thinking',
  common_Generating: 'Generating...',
  common_Better: 'Better',
  common_Same: 'Same',
  common_Worse: 'Worse',
  common_Stop: 'Stop',
  common_Submit: 'Submit',
  common_Cancel: 'Cancel',
  common_Confirm: 'Confirm',
  common_Copy: 'Copy',
  common_Copied: 'Copied',
  common_Email: 'Email',
  common_Edit: 'Edit',
  common_Delete: 'Delete',
  common_Built_by_Tate_A_Tate: 'Built by Tate-A-Tate'
};

const SKILL = {
  skill_File_Knowledge: 'File Knowledge',
  skill_Web_Knowledge: 'Web Knowledge',
  skill_Prior_Knowledge: 'Prior Knowledge',
  skill_Workflow: 'Workflow',
  skill_API_Development: 'API Development',
  skill_Custom_Code: 'Custom Code',
  skill_Remote_MCP: 'Remote MCP'
};

// 请求错误
const REQUEST_ERROR = {
  request_Please_change_a_topic: 'Please change a topic', // 回答命中敏感词提示
  request_Error_occurred: 'Error occurred', // 消息错误
  request_system_request_error: 'System request error', // 系统请求异常
  request_no_permission: 'No permission for the current operation', // 当前操作没有权限
  request_Please_check_your_question: 'Please check your question', // 问题命中敏感词报错
  request_access_resource_does_not_exist: 'Access resource does not exist', // 访问资源不存在
  request_Error_occurred_stopped_generated: 'Error occurred, stopped generated', // 消息生成错误，工作流报错
  request_unknown_system_error: 'Unknown system error, please feedback to the administrator', // 系统未知错误，请反馈给管理员
  request_authentication_failed: 'Authentication failed and system resources cannot be accessed' // 认证失败，无法访问系统资源
};

// 聊天机器人列表
const CHAT_BOT_LIST = {
  chat_Like: 'Like',
  chat_Source: 'Source',
  chat_Dislike: 'Dislike',
  chat_Read_aloud: 'Read aloud', // 语音播放
  chat_Regenerate: 'Regenerate', // 重新生成
  chat_Shared_link: 'Shared link',
  chat_Reached_limits: 'Reached limits', // 重新生成 - 已达上限
  chat_Guide_questions: 'Guide questions',
  chat_Already_new_chat: 'Already new chat', // 已经为新会话
  chat_Rate_this_answer: 'Rate this answer', // 重新生成 - 评价
  chat_Stopped_generated: 'Generation stopped', // 停止生成
  chat_Developer_process: 'Developer process', // 开发者模式
  chat_Feedback_cancelled: 'Feedback cancelled', // 回答取消点赞
  chat_Reason_of_disliking: 'Reason of disliking', // 点踩 - 反馈标题
  chat_Message_your_question: 'Message your question',
  chat_Question_templates: 'Question templates', // 快捷指令
  chat_Thanks_for_your_support: 'Thanks for your support', // 回答点赞
  chat_Text_content_is_required: 'Text content is required',
  chat_Thanks_for_your_feedback: 'Thanks for your feedback',
  chat_Message_your_question_or_drag_to_upload: 'Message your question or drag to upload',
  chat_Thanks_for_your_feedback_We_will: 'Thanks for your feedback! We\'ll review it and improve.',
  chat_Optional_Please_tell_us_more_about_your_experience: '(Optional) Please tell us more about your experience',
  chat_Wrong_answer: 'Wrong answer',
  chat_Does_not_understand_my_question: 'Does not understand my question',
  chat_Typos: 'Typos',
  chat_Incorrect_facts: 'Incorrect facts',
  chat_Blank_answer: 'Blank answer',
  chat_Lack_of_professionalism: 'Lack of professionalism',
  chat_Context_is_not_understood: 'Context is not understood',
  chat_Illegal_content: 'Illegal content',
  chat_Others: 'Others',
  chat_Delete_chat_permanently: 'Delete chat permanently',
  chat_Delete_chat_permanently_confirm: 'After deletion, this conversation cannot be recovered. Are you sure you want to delete it?'
};

// menu
const MENU = {
  menu_Today: 'Today',
  menu_new_chat: 'New Chat',
  menu_Logged_in: 'Logged in',
  menu_Yesterday: 'Yesterday',
  menu_Last_7_days: 'Last 7 days',
  menu_No_chat_yet: 'No chat yet',
  menu_Subscription: 'Subscription',
  menu_chat_History: 'Chat History',
  menu_please_log_in: 'Please log in',
  menu_Anonymous_user: 'Anonymous user',
  menu_See_more_history_chats: 'See more history chats',
  menu_Retain_7_day_chat_history: 'Retain 7-day chat history'
};

// 文件上传
const UPLOAD = {
  upload_Incorrect_format: 'Incorrect format',
  upload_Files_cannot_exceed: 'Files cannot exceed {number}MB',
  upload_Images_cannot_exceed: 'Images cannot exceed {number}MB',
  upload_Drag_and_drop_here_to_upload: 'Drag and drop here to upload',
  upload_No_more_than_imgs: 'No more than {number} images',
  upload_No_more_than_file: 'No more than {number} files',
  upload_Upload_failed: '{name} Upload failed, please try again later',
  upload_Upload_failed_empty: 'Upload failed. The file content is empty',
  upload_Once_upload_up_to_fileListLimit_attachments: 'Once upload up to {fileListLimit} attachments',
  upload_file: 'Files: Up to {fileListLimit} (DOC/DOCX/PDF/TXT, under {FILE_SIZE}MB each)',
  upload_img: 'Images: Up to {imgListLimit} (JPEG/JPG/PNG, under {IMG_SIZE}MB each)',
  upload_img_file: 'Images: Up to {imgListLimit} (JPEG/JPG/PNG, under {IMG_SIZE}MB each)\nFiles: Up to {fileListLimit} (DOC/DOCX/PDF/TXT, under {FILE_SIZE}MB each)'
};

// Login
const LOGIN = {
  login_and: 'and',
  login_OR: 'OR',
  login_Log_out: 'Log out',
  login_Welcome_to: 'Welcome to {name}',
  login_Login_success: 'Login success.',
  login_Log_out_success: 'Log out success.',
  login_Privacy_Policy: 'Privacy Policy',
  login_Terms_of_Service: 'Terms of Service',
  login_Log_in_with_Google: 'Log in with Google',
  login_Are_you_sure_to_log_out: 'Are you sure to log out?',
  login_By_logging_in_I_agree_with: 'By logging in I agree with',
  login_Please_enter_your_phone_number: 'Please enter your phone number',
  login_Please_enter_your_phone_number_to_start_using: 'Please enter your phone number to start using',
  login_And_authorize_Tuowen_to_obtain_the_local_machine_number: 'And authorize Tuowen to obtain the local machine number',
  login_Phone_Number: 'Phone Number',
  login_Email: 'Email',
  login_Code: 'Verification code',
  login_Please_enter_email_address: 'Please enter email address',
  login_Obtain_verification_code: 'Verification code',
  login_Resend_count: 'Resend ({count}s)',
  login_Verification_code_has_been_sent: 'Verification code has been sent',
  login_Please_enter_a_6_digit_verification_code: 'Please enter 6 digit code ',
  login_Register_Login: 'Log in',
  login_Verification_failed: 'Verification failed',
  login_Please_complete_the_security_verification_first: 'Please complete the security verification first',
  login_Drag_the_slider_to_the_right_to_complete_verification: 'Drag the slider to the right to complete verification'
};

// 申请
const APPLY = {
  apply_Reason: 'Reason',
  apply_User_name: 'User name',
  apply_Please_enter_the_reason: 'Please enter the reason for application within 500 characters',
  apply_You_need_to_apply_for_approval: 'You need to apply for approval before you can use this robot.',
  apply_Submit_success: 'Submit success',
  apply_The_administrator_will_review_your_application: 'The administrator will review your application, please wait patiently',
  apply_Application_is_under_review: 'Application is under review',
  apply_Application_failed: 'Application failed',
  apply_The_administrator_has_rejected_your_application: 'The administrator has rejected your application',
  apply_Account_disabled: 'Account disabled',
  apply_Your_account_has_been_disabled: 'Your account has been disabled. We apologize for the inconvenience'
};

// 支付
const PAY = {
  pay_USD: 'USD',
  pay_USD_month: 'USD/month',
  pay_width_only: 'with only',
  pay_Unlock_Now: 'Unlock Now',
  pay_Subscribe_Now: 'Subscribe Now',
  pay_Unlimited_usage_no_restrictions: 'Unlimited usage, no restrictions',
  pay_One_time_payment_no_subscriptions: 'One-time payment, no subscriptions',
  pay_Instant_access_no_waiting: 'Instant access, no waiting',
  pay_Continuous_updates_and_improvements: 'Continuous updates and improvements',
  pay_Flexible_cancellation_options: 'Flexible cancellation options',
  pay_Always_stay_up_to_date_with_the_latest_features: 'Always stay up-to-date with the latest features',
  pay_Unlock_Unlimited_Access_to_the_Agent: 'Unlock Unlimited Access to the Agent',
  pay_Get_Unlimited_Access_with_a_Flexible_Subscription: 'Get Unlimited Access with a Flexible Subscription'
};

const MONTH = {
  Jan: 'Jan',
  Feb: 'Feb',
  Mar: 'Mar',
  Apr: 'Apr',
  May: 'May',
  Jun: 'Jun',
  Jul: 'Jul',
  Aug: 'Aug',
  Sep: 'Sep',
  Oct: 'Oct',
  Nov: 'Nov',
  Dec: 'Dec'
};

// 表单校验
const FORM_VALIDATE = {
  validate_phone_null: 'The phone number cannot be empty', // 手机号不能为空
  validate_phone_error: 'The phone number format is incorrect', // 手机号格式不正确
  validate_code_null: 'The verification code cannot be empty', // 验证码不能为空
  validate_code_error: 'Verification code error', // 验证码错误
  validate_email_error: 'The email format is incorrect', // 邮箱格式错误
  validate_email_null: 'The email cannot be empty' // 邮箱不能为空
};

const ERROR_PAGE = {
  error_Try_for_free: 'Try for free',
  error_The_page_you_visited_is_currently_unavailable: 'The page you visited is currently unavailable. You can visit the following website to find more information.',
  error_Tate_A_Tate_a_one_stop_agent_creation_platform: 'Tate-A-Tate, a one-stop agent creation platform.',
  error_achieve_AI_entrepreneurship_monetization: 'Achieve AI entrepreneurship monetization without requiring programming knowledge, building a full-stack AI agent in just 5 minutes, developing from idea to global profitability.'
};

const THINK = {
  think_Thinking: 'Deep thinking...',
  think_Show_thinking: 'Show thinking',
  think_Contains_sensitive_word_generation_stopped: 'Contains sensitive word, generation stopped.'
};

export default {
  ...PAY,
  ...MENU,
  ...SKILL,
  ...MONTH,
  ...APPLY,
  ...LOGIN,
  ...THINK,
  ...COMMON,
  ...UPLOAD,
  ...ERROR_PAGE,
  ...REQUEST_ERROR,
  ...CHAT_BOT_LIST,
  ...FORM_VALIDATE
};
